import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const Header = styled.div`
  background-color: #2a2a2a;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #404040;
`;

export const BackButton = styled.button`
  background: rgba(29, 56, 141, 0.1);
  border: 1px solid rgba(29, 56, 141, 0.3);
  color: #60a5fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(29, 56, 141, 0.2);
    border-color: rgba(29, 56, 141, 0.5);
    color: #93c5fd;
  }
`;

export const DeviceTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const TitleSection = styled.div`
  flex: 1;
`;

export const DeviceName = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #ffffff;
`;

export const DeviceSubtitle = styled.div`
  font-size: 16px;
  color: #888;
  margin-bottom: 4px;
`;

export const DeviceId = styled.div`
  font-size: 14px;
  color: #666;
  font-family: 'SF Mono', Consolas, monospace;
`;

export const StatusSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const ViewDataButton = styled.button`
  background: #1d388d;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
  margin-top: 8px;

  &:hover {
    background: #2d4da3;
  }
`;

export const StatusBadge = styled.div<{ status: 'online' | 'offline' | 'warning' }>`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  ${props => {
    switch (props.status) {
      case 'online':
        return `
          background-color: #1d388d;
          color: #ffffff;
        `;
      case 'warning':
        return `
          background-color: #ffc107;
          color: #000000;
        `;
      case 'offline':
        return `
          background-color: #dc3545;
          color: #ffffff;
        `;
      default:
        return `
          background-color: #6c757d;
          color: #ffffff;
        `;
    }
  }}
  
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;

export const LastUpdate = styled.div`
  font-size: 14px;
  color: #888;
`;

export const KeyMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 24px;
`;

export const MetricCard = styled.div`
  background-color: #333;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #404040;
`;

export const MetricLabel = styled.div`
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  font-weight: 600;
`;

export const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
`;

export const MetricUnit = styled.span`
  font-size: 14px;
  color: #888;
  font-weight: 400;
`;

export const MetricChange = styled.div<{ trend?: 'up' | 'down' | 'stable' }>`
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  ${props => {
    switch (props.trend) {
      case 'up':
        return 'color: #10b981;';
      case 'down':
        return 'color: #ef4444;';
      default:
        return 'color: #888;';
    }
  }}
`;

export const NavigationTabs = styled.div`
  background-color: #2a2a2a;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 1px solid #404040;
`;

export const TabList = styled.div`
  display: flex;
  padding: 4px;
`;

export const Tab = styled.button<{ active?: boolean }>`
  background: ${props => props.active ? '#1d388d' : 'transparent'};
  border: none;
  color: ${props => props.active ? '#ffffff' : '#888'};
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  transition: all 0.2s;
  
  &:hover {
    color: ${props => props.active ? '#ffffff' : '#1d388d'};
  }
  
  ${props => props.active && `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #1d388d;
    }
  `}
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  font-size: 16px;
  color: #888;
`;

export const ErrorContainer = styled.div`
  background-color: #dc3545;
  color: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
`;
